<template>
  <v-card>
    <v-row>
      <v-col class="ma-1">
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Paramètres généraux</v-tab>
          <v-tab> Liste des requetes </v-tab>
          <v-tab> Affiliation des données </v-tab>
          <v-tab> Modules de recherche </v-tab>        
          <v-tab> Actions </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
              <v-row>
                <v-col class="col-md-6 col-12 elevation-1">
                  <h3>Général et tooltip</h3>
                <Select
                :item="{name: 'Quel type de Chart ?',value: 'type',liste: listTypeCharts,
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.type = value['value']; }"
                :valField="displays.params.general.type"
                />
                <TextField                  
                :item="{name:'titre',value:'title',defaultprops:{show:true}}" 
                :keyup="(item,value) => {displays.params.general.title.text = value } "
                :valField="displays.params.general.title.text"/>   
                <TextField                  
                :item="{name:'hauteur en px',value:'title',defaultprops:{show:true}}" 
                :keyup="(item,value) => {displays.params.height = value } "
                :valField="displays.params.height"/> 
                <div class="ma-3 elevation-3 blue lighten-5">
                  Définissez ou se positionne les valeurs et les catégories (pour Bars et Lines) 
                  <Select
                :item="{name: 'donnée horizontale',value: 'value',liste: [{text:'visuel des catégories',value:'category'},{text:'visuel des valeurs',value:'value'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.xaxis.type = value['value']; }"
                :valField="displays.params.general.xaxis.type"
                />              
                <Select
                :item="{name: 'donnée verticale',value: 'value',liste: [{text:'visuel des catégories',value:'category'},{text:'visuel des valeurs',value:'value'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.yaxis.type = value['value']; }"
                :valField="displays.params.general.yaxis.type"
                />
                </div>


                <Select
                :item="{name: 'déclenchement du tooltip',value: 'type',liste: [{text:'sur l\'élément',value:'item'},{text:'sur l\'axice',value:'axis'},{text:'non visible',value:'none'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.tooltip.trigger = value['value']; }"
                :valField="displays.params.general.tooltip.trigger"
                />                    
                <Select
                :item="{name: 'pointage axice',value: 'type',liste: [{text:'sur la ligne',value:'line'},{text:'hombre',value:'shadow'},{text:'à travers',value:'cross'},{text:'non visible',value:'none'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.tooltip.axisPointer.type = value['value']; }"
                :valField="displays.params.general.tooltip.axisPointer.type"
                /> 
                <TextField                  
                :item="{name:'formattage du tooltip',value:'title',defaultprops:{show:true}}" 
                :keyup="(item,value) => {displays.params.general.tooltip.formatter = value } "
                :valField="displays.params.general.tooltip.formatter"/>
                <span class="text-caption">Pour le formattage : '{a}' = le nom de la série, '{b}' = le nom de la valeur, '{c}' = la valeur, '{d}' = le pourcentage de la valeur sur l'ensemble (uniquement sur pie)</span>
                
                
                <h3>affichage des catégories</h3>  
                <SwitchC
                :item="{ name: 'afficher des catégories', value: 'show', defaultprops:{ show: true }}"
                :valField="displays.params.general.label.axislabel.show"
                :change="(item,value) => {displays.params.general.label.axislabel.show = value;}"
                />      
                <TextField                  
                :item="{name:'intervale d\'affichage des catégories',format:'number',value:'title',defaultprops:{show:true,description:'(0 = force l\'affichage de toutes les catégories)',persistenthint:true}}" 
                :keyup="(item,value) => {displays.params.general.label.axislabel.interval = value } "
                :valField="displays.params.general.label.axislabel.interval"/>      
                
                <TextField                  
                :item="{name:'rotation de l\'affichage',value:'title',defaultprops:{show:true,description:'(0, 45, 60 ou autre)',persistenthint:true}}" 
                :keyup="(item,value) => {displays.params.general.label.axislabel.rotate = value } "
                :valField="displays.params.general.label.axislabel.rotate"/>
                
              </v-col>

                <v-col class="col-md-6 col-12 elevation-1">
                <h3>Légende</h3>
                En cas de multiple donnée sur une catégorie, la légende permet de visualiser les intitulés de chaque donnée.
                <SwitchC
                :item="{ name: 'afficher la légende', value: 'show', defaultprops:{ show: true }}"
                :valField="displays.params.general.legend.show"
                :change="(item,value) => {displays.params.general.legend.show = value;}"
                />
                <SwitchC
                :item="{ name: 'légende visible si sa valeur est à zéro', value: 'show', defaultprops:{ show: true }}"
                :valField="displays.params.general.legend.showif0value"
                :change="(item,value) => {displays.params.general.legend.showif0value = value;}"
                />
                <Select
                :item="{name: 'orientation de la légende',value: 'type',liste: [{text:'horizontal',value:'horizontal'},{text:'vertical',value:'vertical'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.legend.orient = value['value']; }"
                :valField="displays.params.general.legend.orient"
                />
                <Select
                :item="{name: 'position de la légende',value: 'type',liste: [{text:'left',value:'left'},{text:'center',value:'center'},{text:'right',value:'right'},{text:'auto',value:'auto'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.legend.left = value['value']; }"
                :valField="displays.params.general.legend.left"
                />
                <h3>grille du graphique</h3>
                permet le margin autour du graphique
                <SwitchC
                :item="{ name: 'ajustement automatique de la grille', value: 'show', defaultprops:{ show: true }}"
                :valField="displays.params.general.grid.containLabel"
                :change="(item,value) => {displays.params.general.grid.containLabel = value;}"
                />
                <TextField                  
                :item=" { name:'décalage gauche',value:'title',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.general.grid.left = value } "
                :valField="displays.params.general.grid.left"/>
                <TextField                  
                :item=" { name:'décalage droit',value:'title',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.general.grid.right = value } "
                :valField="displays.params.general.grid.right"/>
                <TextField                  
                :item=" { name:'décalage bas',value:'title',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.general.grid.bottom = value } "
                :valField="displays.params.general.grid.bottom"/>
                <h3>Affichage du zoom</h3>
                permet d'afficher vue globale du zoom sous le graphique et slider pour voir de plus près
                <SwitchC
                :item="{ name: 'Activer le ZOOM', value: 'show', defaultprops:{ show: true }}"
                :valField="displays.params.general.zoom"
                :change="(item,value) => {displays.params.general.zoom = value;}"
                />
                </v-col>
              </v-row>

              <h3>Boite à outil</h3>
                  affiche des options de switch de graphique sur le front, et permet l'enregistrement d'une image du graphique
                  <SwitchC
                  :item="{ name: 'Activer la toolbox', value: 'show', defaultprops:{ show: true }}"
                  :valField="displays.params.general.toolbox.show"
                  :change="(item,value) => {displays.params.general.toolbox.show = value;}"
                  />

              <v-row v-if="displays.params.general.toolbox.show">
                <v-col class="col-12">
                  <Select
                :item="{name: 'position de la toolboxen horizontal',value: 'type',liste: [{text:'left',value:'left'},{text:'center',value:'center'},{text:'right',value:'right'},{text:'auto',value:'auto'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.toolbox.left = value['value']; }"
                :valField="displays.params.general.toolbox.left"
                />
                <Select
                :item="{name: 'orientation de la toolbox',value: 'type',liste: [{text:'horizontal',value:'horizontal'},{text:'vertical',value:'vertical'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.toolbox.orient = value['value']; }"
                :valField="displays.params.general.toolbox.orient"
                />
                <Select
                :item="{name: 'position de la toolbox en vertical',value: 'type',liste: [{text:'top',value:'top'},{text:'center',value:'center'},{text:'bottom',value:'bottom'}],
                defaultprops:{ show: true}}"
                :change="(item,value) => { displays.params.general.toolbox.top = value['value']; }"
                :valField="displays.params.general.toolbox.top"
                />
                </v-col>
                <v-col class="col-md-6 col-12">
                  <h4>Switch de type de graphique</h4>
                  <SwitchC
                  :item="{ name: 'Activer le switch', value: 'show', defaultprops:{ show: true }}"
                  :valField="displays.params.general.toolbox.feature.magicType.show"
                  :change="(item,value) => {displays.params.general.toolbox.feature.magicType.show = value;}"
                  />
                </v-col>
                <v-col class="col-md-6 col-12">
                  <h4>Sauvegarde du graphique</h4>
                  <SwitchC
                  :item="{ name: 'Activer l\'option de sauvegarde', value: 'show', defaultprops:{ show: true }}"
                  :valField="displays.params.general.toolbox.feature.saveAsImage.show"
                  :change="(item,value) => {displays.params.general.toolbox.feature.saveAsImage.show = value;}"
                  />
                 <TextField                  
                :item=" { name:'titre du bouton',value:'title',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.general.toolbox.feature.saveAsImage.title = value } "
                :valField="displays.params.general.toolbox.feature.saveAsImage.title"/>
                <TextField                  
                :item=" { name:'intitulé de l\'image de sortie',value:'title',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.general.toolbox.feature.saveAsImage.name = value } "
                :valField="displays.params.general.toolbox.feature.saveAsImage.name"/>
                </v-col>
              </v-row>

              <hr>
                <SwitchC
              :item="{ name: 'Afficher le graph uniquement si un filtre est appliqué', value: 'show', defaultprops:{ show: true }}"
              :valField="displays.params.displayiffilter.set"
              :change="(item,value) => {displays.params.displayiffilter.set = value;}"
              />
              <TextField
              v-if="displays.params.displayiffilter.set"
              :item="{ name: 'texte d\'attente du filtre', value: 'text', defaultprops:{ show: true }}"
              :valField="displays.params.displayiffilter.text"
              :keyup="(item,value) => {displays.params.displayiffilter.text = value;}"
              />
            </v-tab-item>

            <v-tab-item>

              <v-btn fab small @click="addListe"><v-icon>mdi-plus</v-icon></v-btn>
            <v-expansion-panels variant="popout" v-model="listQuerysAccordion" class="pa-3">
              <v-expansion-panel v-for="(query, i) in displays.params.listquerys" :key="'lf'+i">
                <v-expansion-panel-header>
                  {{query.key}} ({{query.description}})
                  <template v-slot:actions>
                    <v-btn icon @click="removeListe(i)" v-if="query.key!='default'"><v-icon>mdi-close-thick</v-icon></v-btn>
                  </template> 
                </v-expansion-panel-header>

                <v-expansion-panel-content class="grey lighten-3">

                  <div>
                    <TextField                  
                    :item="{name:'clé',value:'key',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {query.key = value } "
                    :valField="query.key"/>
                    <TextField                  
                    :item="{name:'description',value:'description',defaultprops:{show:true}}" 
                    :keyup="(item,value) => {query.description = value } "
                    :valField="query.description"/>
                    <Select
                      :item="{name: 'table ciblée',value: 'table',liste: listTables,
                      defaultprops:{ show: true,clearable:true } } "
                      :change="(item,value) => { query.table = value['value'] || ''; } "
                      :valField="query.table"
                      />               
                  </div>

                  <v-tabs v-model="tabsFiche" v-if="query.table && query.table!=''">
                    <v-tab> Filtre </v-tab>
                    <v-tab> Champs </v-tab>
                    <v-tabs-items v-model="tabsFiche">
                      <v-tab-item>
                        <Filtre :page="page" :filtre="query.filtre" :table="query.table" />
                      </v-tab-item>
                      <v-tab-item> 
                        <Fields :page="page" :champs="query.champs" :modalKey="modalKey" :filter="query.filtre" :table="query.table" />
                        </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>

                </v-expansion-panel-content>  

              </v-expansion-panel>
            </v-expansion-panels>

            </v-tab-item>


            <!-- Affiliation des données -->
            <v-tab-item>
              <v-row no-gutters>
                <v-col class="col-md-6 col-12 pa-2 elevation-1">
                  <!-- Affiliation des catégorie pour affichage -->
                <h3>Affiliation des catégories</h3>
                <SwitchC
                :item="{ name: 'Activer la catégorie en tant que tanche de date', value: 'show', 
                defaultprops:{ show: true }}"
                :valField="displays.params.fielddatacategorie.setdate"
                :change="(item,value) => {displays.params.fielddatacategorie.setdate = value;}"
                />

                <div v-show="displays.params.fielddatacategorie.setdate">
                  <TextField                  
                  :item=" { name:'Date de début',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.getdate.deb = value } "
                  :valField="displays.params.fielddatacategorie.getdate.deb"/>
                  <TextField                  
                  :item=" { name:'Date de fin',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.getdate.fin = value } "
                  :valField="displays.params.fielddatacategorie.getdate.fin"/>
                  <TextField                  
                  :item=" { name:'Intervale',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.getdate.interval = value } "
                  :valField="displays.params.fielddatacategorie.getdate.interval"/>
                  <TextField                  
                  :item=" { name:'Relationnel catégorie<->données en formatage date (php)',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.getdate.relationkey = value } "
                  :valField="displays.params.fielddatacategorie.getdate.relationkey"/>
                  <TextField                  
                  :item=" { name:'affichage de la date',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.getdate.displayformat = value } "
                  :valField="displays.params.fielddatacategorie.getdate.displayformat"/>
                </div>

                <div v-show="!displays.params.fielddatacategorie.setdate">
                  <TextField                  
                  :item=" { name:'clé de requete faisant l\'objet des catégories',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.querykey = value } "
                  :valField="displays.params.fielddatacategorie.querykey"/>
                  <TextField                  
                  :item=" { name:'nom du champ affiché pour la catégorie',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.field = value } "
                  :valField="displays.params.fielddatacategorie.field"/>
                  <TextField                  
                  :item=" { name:'relationnel du champ catégorie<->valeur',value:'categ',defaultprops:{show:true} } " 
                  :keyup="(item,value) => { displays.params.fielddatacategorie.relationkey = value } "
                  :valField="displays.params.fielddatacategorie.relationkey"/>
                </div>
                </v-col>  
                <v-col class="col-md-6 col-12 pa-2 elevation-1">
                  <h3>Affiliation de la légende</h3>
                <TextField                  
                :item=" { name:'clé de requete faisant l\'objet de la légende',value:'categ',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.fielddatalegend.querykey = value } "
                :valField="displays.params.fielddatalegend.querykey"/>
                <TextField                  
                :item=" { name:'nom du champ affiché pour la légende',value:'categ',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.fielddatalegend.field = value } "
                :valField="displays.params.fielddatalegend.field"/>
                <TextField                  
                :item=" { name:'relationnel du champ légende<->valeur',value:'categ',defaultprops:{show:true} } " 
                :keyup="(item,value) => { displays.params.fielddatalegend.relationkey = value } "
                :valField="displays.params.fielddatalegend.relationkey"/>
                  </v-col>  
              </v-row>
              
              <div class="pa-3 elevation 1">

              </div>

            <div class="pa-3 elevation 1">
                <h3>Affiliation des données</h3>

                  <v-btn fab small @click="addSerie"><v-icon>mdi-plus</v-icon></v-btn>
                  <div v-for="(serie, i) in displays.params.listseries" :key="'lf'+i" class="ma-3 rounded blue lighten-5">
                    <v-btn icon @click="removeSerie(i)"><v-icon>mdi-close-thick</v-icon></v-btn>
                    <v-row>
                      <v-col>
                        <TextField                  
                        :item="{name:'description (juste pour info.. n\'est pas utilisé dans les charts)',value:'description',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {serie.description = value } "
                        :valField="serie.description"/>
                        <TextField                  
                        :item="{name:'clé de requete faisant l\'objet des valeurs',value:'relationkey',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {serie.querykey = value } "
                        :valField="serie.querykey"/>
                        <TextField                  
                        :item="{name:'Valeurs de la série (mentionner le AS)',value:'relationkey',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {serie.keyvalue = value } "
                        :valField="serie.keyvalue"/>
                        <TextField                  
                        :item="{name:'Nom de la valeur de la serie',value:'relationkey',defaultprops:{show:true,description:'Utilisez la variable [[line||monAS]] pour la provenance de la requete, sinon texte libre'}}" 
                        :keyup="(item,value) => {serie.namevalue = value }"
                        :valField="serie.namevalue"/>
                        <TextField                  
                        :item="{name:'champ relationnel valeur<->catégorie',value:'relationkey',defaultprops:{show:true,description:'mentionnez le AS qui fait référence à la catégorie'}}" 
                        :keyup="(item,value) => {serie.relationkey = value }"
                        :valField="serie.relationkey"/>
                        <SwitchC
                        :item="{ name: 'Activer une boucle à cette série à partir d\'un champ de la requete', value: 'show', 
                        defaultprops:{ show: true,description:'En activant cette case, vous pourrez cibler un champ qui va permettre de créer autant de séries que d\'itération de ce champ.',persistenthint:true }}"
                        :valField="serie.setloopseries"
                        :change="(item,value) => {serie.setloopseries = value;}"
                        />
                        <TextField       
                        v-if="serie.setloopseries"           
                        :item="{name:'relationnel du champ légende<->valeur',value:'loopfrom',defaultprops:{show:true,description:'mentionnez le AS qui fait référence au champ de la requete'}}" 
                        :keyup="(item,value) => {serie.loopfrom = value }"
                        :valField="serie.loopfrom"/>
                      </v-col>
                      <v-col>
                        <TextField                  
                        :item="{name:'Nom de la série',value:'name',defaultprops:{show:true,description:'mentionnez AS du champ de la requete'}}" 
                        :keyup="(item,value) => {serie.name = value } "
                        :valField="serie.name"/> 
                        <Select
                        :item="{name: 'position du label',value: 'value',liste: [
                          {text:'(pie) intérieur',value:'inside'},{text:'(pie) exterieur',value:'outside'},
                          {text:'(bar-line) top',value:'top'},{text:'(bar-line) right',value:'right'},
                          {text:'(bar-line) bottom',value:'bottom'},{text:'(bar-line) left',value:'left'},
                          {text:'(bar-line) inside',value:'inside'},{text:'(bar-line) insideLeft',value:'insideLeft'},
                          {text:'(bar-line) insideRight',value:'insideRight'},{text:'(bar-line) exterieur',value:'outside'},
                          {text:'(bar-line) insideBottom',value:'insideBottom'},{text:'(bar-line) insideTop',value:'insideTop'},
                          {text:'(bar-line) insideTopLeft',value:'insideTopLeft'},{text:'(bar-line) insideBottomLeft',value:'insideBottomLeft'},
                          {text:'(bar-line) insideTopRight',value:'insideTopRight'},{text:'(bar-line) insideBottomRight',value:'insideBottomRight'},
                        ],
                        defaultprops:{ show: true}}"
                        :change="(item,value) => { serie.label.position = value['value']; }"
                        :valField="serie.label.position"
                        />
                        <TextField                  
                        :item="{name:'couleur des éléments',value:'name',defaultprops:{show:true,description:'écrivez \'random\' pour couleur aleatoire, sinon [[line||monAS]] pour la couleur de la requette '}}" 
                        :keyup="(item,value) => {serie.color = value } "
                        :valField="serie.color"/>
                        <TextField                  
                        :item="{name:'border radius des éléments',format:'number',value:'name',defaultprops:{show:true}}" 
                        :keyup="(item,value) => {serie.borderradius = value } "
                        :valField="serie.borderradius"/>
                        <TextField   
                        v-if="displays.params.general.type=='pie'"               
                        :item="{name:'radius de début',value:'name',defaultprops:{show:true,description:'mentionnez AS du champ de la requete'}}" 
                        :keyup="(item,value) => {serie.radius.deb = value } "
                        :valField="serie.radius.deb"/> 
                        <TextField    
                        v-if="displays.params.general.type=='pie'"               
                        :item="{name:'radius de fin',value:'name',defaultprops:{show:true,description:'mentionnez AS du champ de la requete'}}" 
                        :keyup="(item,value) => {serie.radius.fin = value } "
                        :valField="serie.radius.fin"/>
                        
                        <h3>Actions sur click:</h3> 

                        <SwitchC
                        :item="{ name: 'activer une action sur click d\'un élément', value: 'show', 
                        defaultprops:{ show: true,persistenthint:true }}"
                        :valField="serie.onclick.set"
                        :change="(item,value) => {serie.onclick.set = value;}"
                        />
                          <div v-if="serie.onclick.set">
                            <Select
                            :item="{name: 'type d\'action',value: 'value',liste: [{text:'envoi de GET',value:'querys'},{text:'action spécifique',value:'action'}],
                            defaultprops:{ show: true}}"
                            :change="(item,value) => { serie.onclick.type = value['value']; }"
                            :valField="serie.onclick.type"
                            />
                              <div v-if="serie.onclick.type=='querys'">
                                <p><i><b>ATTENTION : Veuillez mentionner en AS, la clé réelle du champ, pour que le rafraichissement des autres modules fonctionnent.</b></i></p>
                                  <p><i><b>Chaque clé aura l'id du module en début (idmodule_monas=valeur). Cela ne s'applique pas pour les 
                                    AS commencants par d_ (fait pour les dates)</b></i></p>
                                <Autocomplete
                                  :item="{
                                    name: 'Champs pour les envois de GET',
                                    value: 'globalsearch',
                                    defaultprops: { show: true, multiple: true },
                                    liste: listFieldForQuerys(serie.querykey,i),
                                  }"
                                  :valField="serie.onclick.querys"
                                  :change="(item,value,selected) => { updateSeriesQuery(i, value,selected) }"
                                />
                              </div>
                              <div v-if="serie.onclick.type=='action'">
                                <Autocomplete :item="{
                                defaultprops:{ show: true, chips:true,multiple:true,deletablechips:true },
                                name: 'actions affichés sur l\'élément',
                                value: 'none',
                                liste: listActions,
                                }" :change="(item,value)=> {updateActionsSerie(i,value) }" :valField="serie.onclick.actions" />
                              </div>
                          </div>

                      </v-col>
                      </v-row>


                  </div>

              </div>
            </v-tab-item>


            <v-tab-item>
              <!-- Modules de recherche -->
              <div class="text-h6">
                Si le ou les modules sélectionnés se trouvent sur la même page,
                ils interagieront avec le tableau
              </div>

              <SimpleTable
                :Headers="[
                  { text: 'ID', value: 'id' },
                  { text: 'type', value: 'type' },
                  { text: 'Nom', value: 'name' },
                  { text: 'Table', value: 'table' },
                  { text: 'champs', value: 'champs' },
                ]"
                :datas="dataTableSearch"
                :selected="displays.params.searchmodule"
                keyRow="id"
                @getselected="getselected"
              />

              <div class="text-h6">
                champs selectionnés pour la recherche globale
              </div>
              <Autocomplete
                :item="{
                  name: 'Champs ciblés pour recherche globale',
                  value: 'globalsearch',
                  defaultprops: { show: true, multiple: true },
                  liste: listFields,
                }"
                :valField="displays.params.globalsearch"
                :change="changeGlobalSearch"
              />
            </v-tab-item>

            <v-tab-item>
              <listActions :page="page" :module="module" :key="reload" @listActions="getActions" :modalKey="modalKey"/>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

    import { admin } from '../mixins';


export default {
  name: "chartsModule",

    mixins : [admin],

  data: function () {
    return {
      tab: null,
      displays: this.module.displays,
      dataTableSearch: [],
      listFields: [],
      reload : 0,
      listQuerysAccordion : '',
      listActions : [],
      tabsFiche: '',
      listTables : [],
      listTypeCharts : [{text:'barre empilé',value:'barstack'},{text:'Pie',value:'pie'},{text:'Bar',value:'bar'},{text:'Line',value:'line'}],
    };
  },

  watch: {
    showMod: {
      // permet de rafraichir quand la modal de la page se ferme
      handler(val) {
        if (val.show === false) {
          this.reload++;
        }
      },
      deep: true,
    },
  },


  methods: {

    getsearchFromAPI() {
      this.API({
        type: "post",
        url: "/engine/module/list",
        params: { type: ["search","echarts"] },
      }).then((resp) => {
        resp.data.forEach((v) => {
          let champs = (v.displays.params.champs) ? v.displays.params.champs.join(", ") : "--";
          this.dataTableSearch.push({
            id: v.id,
            type: v.type,
            name: v.name,
            table: v.table,
            champs: champs,
          });
        });
        // pour intégrer la recherche globale :
        this.dataTableSearch.push({
          id: "global",
          champs: "sensible au champ de la recherche globale",
        });
      });
    },

    //permet de récupérer les champs issues de la requete pur les insérer dans la recherche globale
    getFields() {
      this.API({
        type: "post",
        url: "engine/module/getfieldswithjunctions",
        params: { table: this.module.table, filter: this.displays.filter },
      }).then((resp) => {
        this.Fields = resp.data.fields;
        resp.data.fields.forEach((field) => {
          this.listFields.push({
            text: field.table + "." + field.field,
            value: field.cle,
          });
          if (field.table == this.module.table)
            this.FieldsOfModuleTable.push({
              text: field.table + "." + field.field,
              value: field.cle,
              default: "value",
            });
        });
      });
    },


  addListe() {
    
    let copieDefault = JSON.parse(JSON.stringify(this.buildingParameters.echarts.defaultquerys))
    this.displays.params.listquerys.push(copieDefault);
  },

  removeListe(index) {
    this.displays.params.listquerys = this.displays.params.listquerys.filter((el,i)=> i!=index);
  },


  addSerie() {
    
    let copieDefault = JSON.parse(JSON.stringify(this.buildingParameters.echarts.defaultserie))
    this.displays.params.listseries.push(copieDefault);
  },

  removeSerie(index) {
    this.displays.params.listseries = this.displays.params.listseries.filter((el,i)=> i!=index);
  },

  listFieldForQuerys(key,serie) {
    //permet de créer la liste des champs issues de la clé de la série 
      let list = this.displays.params.listquerys.find(el => el.key == key).champs;
      let array = []
      let checkIfPresent = []
      list.forEach((e) => {
        array.push({text:e.as,value:e.as})
        checkIfPresent.push(e.as);
      })

      //et en meme temps check si toute ces clé sont dans displays.params.listseries.onclick.querys, si il n'y est pas, on suppriem par défaut ://
      this.displays.params.listseries[serie].onclick.querys.forEach((seriekey) => {
        if(!checkIfPresent.includes(seriekey)) {
          this.displays.params.listseries[serie].onclick.querys = this.displays.params.listseries[serie].onclick.querys.filter(item => item!=seriekey)
        }
      })

      return array;
    },

  updateSeriesQuery(serie,value) {
    this.displays.params.listseries[serie].onclick.querys = []
    for (var selected in value) {
        if (typeof value[selected] == "object") {
          this.displays.params.listseries[serie].onclick.querys.push(value[selected]['value']);
        } else {
          this.displays.params.listseries[serie].onclick.querys.push(value[selected]);
        }
      }
  },

  getActions(datas) {
      this.listActions = []
      datas.forEach((v) => {
        this.listActions.push({text:v.name,value:v.id});
      })
  },

  updateActionsSerie(serie,value) {
    this.displays.params.listseries[serie].onclick.actions = []
    for (var selected in value) {
        if (typeof value[selected] == "object") {
          this.displays.params.listseries[serie].onclick.actions.push(value[selected]['value']);
        } else {
          this.displays.params.listseries[serie].onclick.actions.push(value[selected]);
        }
      }
    },

    changeGlobalSearch(item, value, selectedKey) {
      this.displays.params.globalsearch = [];
      for (var selected in value) {
        if (typeof value[selected] == "object") {
          this.displays.params.globalsearch.push(value[selected][selectedKey]);
        } else {
          this.displays.params.globalsearch.push(value[selected]);
        }
      }
      this.$emit("recepVal", this.displays);
    },

    getselected(val) {
      this.displays.params.searchmodule = val;
      this.$emit("recepVal", this.displays);
    },

  },

  mounted() {
    this.getsearchFromAPI();

    this.API({type:'post', url:'/engine/module/actions' , params:{module:this.module.id}}).then((resp) => {       
        this.getActions(resp.data);
      });


    this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
                    resp.data.forEach((table) => {
                        this.listTables.push({text:table,value:table})
                    })
                    
                })
    //this.getFields();
  },
};
</script>
